const toast = (info, duration = 3, extraInfo?: any) => {
  const Toast = Mach.requireModule('Toast');
  Toast.show(info, duration, extraInfo);
};

export { toast };
